import React from 'react';
import { useRouter } from 'next/router';

import useUI from 'hooks/use-ui';

import PageTitle from './title';
import PageDescription from './description';
import Favicons from './favicons';
import ProductTags from './product-tags';
import DispensaryTags from './dispensary-tags';
import Meta from './meta';
import CanonicalTag from './canonical-tag';
import AppleTouchIcons from './apple-touch-icons';

import { getPageVariant } from './utils.ts';

function useMetaRobotsContent(customRobotsRule) {
  const UI = useUI();

  if (customRobotsRule) {
    return customRobotsRule;
  }
  if (UI.isVariant(`embedded`) || UI.isVariant(`kiosk`)) {
    return `noindex,follow`;
  }

  return `index,follow`;
}

export default function MetaTags(props) {
  const { query, asPath } = useRouter();
  const { variant = getPageVariant(query, asPath), location, customRobotsRule = undefined } = props;
  const robotsContent = useMetaRobotsContent(customRobotsRule);

  return (
    <React.Fragment>
      <PageTitle variant={variant} location={location} />
      <PageDescription variant={variant} location={location} />
      <Favicons variant={variant} />
      <Meta property='viewport' content='width=device-width,initial-scale=1,maximum-scale=1' />
      <Meta property='robots' content={robotsContent} />
      <Meta property='googlebot' content={robotsContent} />
      <CanonicalTag />
      <AppleTouchIcons />
      {(variant === 'product' || variant === 'dispensaryProduct') && <ProductTags url={asPath} />}
      {variant === 'dispensary' && <DispensaryTags url={asPath} />}
    </React.Fragment>
  );
}
